export enum ResponseStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}
